import QueryFilter from '../../../helpers/query-filter';
import { togglableFilters } from '../../../shared/togglable-filters';
import useHistory from './useHistory';

const Ranges = [
  'leasingPrice',
  'businessLeasingPrice',
  'price',
  'mileage',
  'enginePower',
  'modelYear',
];
const RangesTranslation = {
  leasingPrice: 'Privatleasing',
  businessLeasingPrice: 'Företagsleasing',
  price: 'Pris',
  mileage: 'Mätarställning',
  enginePower: 'Hästkrafter',
  modelYear: 'Modellår',
};
const Toggleable = [
  'deductibleVat',
  'mrf',
  'isAuthorizedResellerForManufacturer',
  'hasManufacturerPackaging',
  'hasMedia',
  'ecom',
  'leasing',
  'businessLeasing',
  'isAuctionItem',
];

export interface PrettyHistory {
  queryFilter: QueryFilter;
  displayName: string[];
}

const usePrettyHistory = (): PrettyHistory[] => {
  const history = useHistory();

  return history.map((historyItem) => {
    const queryFilter = new QueryFilter(historyItem.query);
    const spatial = queryFilter.getSpatial();
    const keys = spatial
      ? queryFilter
          .getKeys()
          .filter((x) => !['lat', 'lon', 'position.location', 'position.name'].includes(x))
      : queryFilter.getKeys();

    const result = {
      queryFilter,
      displayName: keys.reduce(
        (prev, key) => {
          if (Ranges.includes(key)) {
            const range = queryFilter.getRange(key);
            const rangeTranslation =
              RangesTranslation?.[key as keyof typeof RangesTranslation] ?? key;
            if (range.min && range.max) {
              prev.push(`${rangeTranslation} ${range.min} - ${range.max}`);
            } else if (range.min) {
              prev.push(`${rangeTranslation} ${range.min}`);
            } else if (range.max) {
              prev.push(`${rangeTranslation} ${range.max}`);
            }
          } else if (Toggleable.includes(key)) {
            if (queryFilter.has(key)) {
              prev.push(togglableFilters().find((x) => x.id === key)?.displayName || key);
            }
          } else {
            prev.push(queryFilter.get(key).join(', '));
          }
          return prev;
        },
        spatial?.name ? [spatial.name] : ([] as string[]),
      ),
    };

    if (queryFilter.hasQuery()) {
      result.displayName.push(`"${queryFilter.getQuery()}"`);
    }
    return result;
  });
};

export default usePrettyHistory;
